import { IEX_STATE_CODES } from '@constants/configs/states';

export const showQualifyhardshipQTooltip = [IEX_STATE_CODES.PA, IEX_STATE_CODES.VA, IEX_STATE_CODES.IL];
export const defaultHardshipTableVisibility = [
    IEX_STATE_CODES.GA,
    IEX_STATE_CODES.ID,
    IEX_STATE_CODES.MN,
    IEX_STATE_CODES.NM,
    IEX_STATE_CODES.NV,
    IEX_STATE_CODES.PA,
    IEX_STATE_CODES.VA,
    IEX_STATE_CODES.IL,
];
export const seekingCoverageEnabledStates = [
    IEX_STATE_CODES.GA,
    IEX_STATE_CODES.NJ,
    IEX_STATE_CODES.NM,
    IEX_STATE_CODES.NV,
    IEX_STATE_CODES.PA,
    IEX_STATE_CODES.VA,
    IEX_STATE_CODES.IL,
];
export const seekingCoverageTooltipEnablesStates = [
    IEX_STATE_CODES.GA,
    IEX_STATE_CODES.NM,
    IEX_STATE_CODES.NV,
    IEX_STATE_CODES.PA,
    IEX_STATE_CODES.VA,
    IEX_STATE_CODES.IL,
];
export const showEligibleMembersHeaderStates = [
    IEX_STATE_CODES.GA,
    IEX_STATE_CODES.ID,
    IEX_STATE_CODES.MN,
    IEX_STATE_CODES.NM,
    IEX_STATE_CODES.NV,
    IEX_STATE_CODES.PA,
    IEX_STATE_CODES.VA,
    IEX_STATE_CODES.IL,
];
export const householdMembersTooltipEnablesStates = [
    IEX_STATE_CODES.GA,
    IEX_STATE_CODES.NM,
    IEX_STATE_CODES.NV,
    IEX_STATE_CODES.PA,
    IEX_STATE_CODES.VA,
    IEX_STATE_CODES.IL,
];
export const tobaccoUseCheckRequiredStates = [IEX_STATE_CODES.MN];
export const disclaimerMessages = [
    'indportal.tobacco.privacyNotice.heading',
    'indportal.tobacco.disclaimer1',
    'indportal.tobacco.disclaimer2',
    'indportal.tobacco.disclaimer3',
    'indportal.tobacco.disclaimer4',
];

